module.exports = function (a) {
    a.preventDefault();
    var guid = $(this).data('guid');
    // //
    // // var author = $(this).data('composer');
    // // var isrc = $(this).data('isrc');
    //
    // var html = 'HELP';
    // // if(composer != '' && composer == author){
    // //     html = html+'<p>' + Lang.get('authorisations.info_dialog.author_and_composer') + ': <br><span class="label label-inverse">'+composer+'</span></p>';
    // // }else{
    // //     if(composer != ''){
    // //         html = html+'<p>' + Lang.get('authorisations.info_dialog.composer') + ': <br><span class="label label-inverse">'+composer+'</span></p>';
    // //     }
    // //     if(author != ''){
    // //         html = html+'<p>' + Lang.get('authorisations.info_dialog.author') + ': <br><span class="label label-inverse">'+author+'</span></p>';
    // //     }
    // // }
    // //
    // // if(isrc != ''){
    // //     html = html+'<p>' + Lang.get('authorisations.info_dialog.isrc_code') + ': <br><span class="label label-inverse">'+isrc+'</span></p>';
    // // }
    //
    // bootbox.alert(html, function() {
    //     //console.log("Alert Callback");
    // });

    $.ajax({
        type: "GET",
        url: laroute.route('public::propositions::ajax::get_lists', {'guid': guid})
    }).done(function (msg) {
        console.log(msg);

        if (msg.error) {
            swal({
                title:  msg.message,
                type: "error",
            });
        }else{
            swal({
                title: 'Zaproponuj utwór do listy propozycji',
                text:  'Wybierz listę do której chcesz zaproponować ten utwór.',
                type: "info",
                input: "select",
                showCancelButton: true,
                showLoaderOnConfirm: true,
                closeOnConfirm: false,
                // animation: "slide-from-top",
                confirmButtonText: 'Proponuj',
                cancelButtonText: 'Anuluj',
                inputPlaceholder: 'Wybierz listę',
                inputOptions: msg.lists,
                preConfirm: function (inputValue) {
                    return new Promise(function (resolve, reject) {
                        //noinspection EqualityComparisonWithCoercionJS
                        if (inputValue == "") {
                            reject('Wybierz którąś listę!');
                            return false
                        }

                        $.ajax({
                            type: "POST",
                            url: laroute.route('public::propositions::ajax::propose', {'guid': guid}),
                            data: {
                                list: inputValue
                            }
                        }).done(function (msg) {
                            if (msg.error) {
                                reject(msg.message);
                            }else{
                                resolve();
                            }
                        }).error(function (msg) {console.log(msg);reject('ERROR');});
                    })
                },
            }).then(
                function (inputValue) {
                    swal({
                        title: 'Propozycja została zapisana.',
                        type: "success"
                    });
                },
                // handling the promise rejection
                function (dismiss) {}
            );
        }
    });





};